import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { supportedLanguages, type SupportedLanguage } from "@/lib/i18n";
import { getLocalizedSlug } from '@/lib/slugUtils';
interface FilloutButtonProps {
  className?: string;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  children: React.ReactNode;
  onClick?: () => void;
}
const FilloutButton = ({ 
  className, 
  variant = 'secondary', 
  size = 'default', 
  children,
  onClick
}: FilloutButtonProps) => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: SupportedLanguage }>();
  const currentLang = lang && supportedLanguages.includes(lang) ? lang : 'en';

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    
    // Navigate to the price form page using localized slug with scroll parameter
    const localizedSlug = getLocalizedSlug('price-form', currentLang);
    navigate(`/${currentLang}/${localizedSlug}?scroll=form`);
  };

  return (
    <Button 
      variant={variant}
      size={size}
      className={cn("hover:scale-105 transition-elegant shadow-elegant", className)}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};

export default FilloutButton;